<template>
  <div class='h100vh-100'>
    <div class="h-subTabs h-mmlTabs">
      <command-exec v-if='refresh' ref='mmlCommandExec' @do-exec='doExec' @sync-time='syncTime'></command-exec>
    </div>
    <div class='h-line'></div>
    <div ref='respConsoleScroll' class='h-scroll h-whiteBg h-mml-lbbigbox'>
      <command-resp ref='mmlResp' v-show='!showMassModRecords' @exec-next-mml='execNextMML'
                    @exec-stop='execStop'></command-resp>
      <mod-records ref='mmlModRecords' v-show='showMassModRecords' :mod-records='modRecords'
                   :mod-columns='modColumns'></mod-records>
    </div>
  </div>
</template>
<script>
  import {createNamespacedHelpers} from 'vuex';
  import CommandExec from '@/components/mmlconfig/rightPanel/CommandExec.vue';
  import CommandResp from '@/components/mmlconfig/rightPanel/CommandResp.vue';
  import ModRecords from '@/components/mmlconfig/rightPanel/ModRecords.vue';
  import clearMoVuex from '@/components/mmlconfig/mixins/clearMoVuex';
  import packageParams from '@/components/mmlconfig/mixins/packageParams';
  import bus from '../bus.js';

  const {mapGetters, mapMutations} = createNamespacedHelpers('mmlconfig');
  export default {
    name: 'right-panel',
    components: {
      CommandExec,
      CommandResp,
      ModRecords
    },
    mixins: [clearMoVuex, packageParams],
    data() {
      return {
        // 命令行清除计算标识 eg.经高危操作提示，用户取消操作后，仍保留该行mml在codemirror中
        stopFlag: 0,
        refresh: true,
        modRecords: [],
        modColumns: [],
        cmdList: [],
        dangerOperChecked: false,
        showMassModRecords: false,
        execTime: 0
      };
    },
    watch: {
      massModifyMode(newV) {
        // 若不是批量修改模式，需要隐藏
        console.log('massModifyMode change:', newV);
        if (!newV) {
          this.showMassModRecords = false;
        }
      }
    },
    computed: {
      ...mapGetters(['currentNode', 'currentMo', 'massModifyMode', 'isMassModExecing', 'cmdMode']),
    },
    created() {
      sessionStorage.setItem("mml_export_mos", "");
      bus.$on('refreshAndLoadTabs', (moData) => {
        // clear the vuex of mo first
        this.clearMoVuex();
        // 如果有正在进行的执行操作 停止操作
        this.execStop();
        this.refreshCommandExec(moData);
      });
      bus.$on('showMassModRecord', (modRecords) => {
        this.showMassModRecord(modRecords);
        this.$refs.mmlModRecords.clearSelectedRows();
      });
    },
    mounted() {
      console.log('---------rightPanel-------');
    },
    methods: {
      ...mapMutations(['changeMo', 'changeCommand', 'changeMassModMode', 'changeMassModExecingState',
        'changeCmdMode', 'changeMmlOperButtonDisabled', 'changeMmlCmdButtonDisabled']),
      // 不得不把执行逻辑迁移至此，否则这个破tabs组件如果要使用正常 必须要重新v-if command-exec 组件，这样当切换mo时之前的执行就中断了
      // 所有MML执行的入口 包括单条、批量和CMD dangerOperChecked状态只有批量修改直接执行的模式有意义
      doExec(cmdList, cmdMode) {
        console.log("doExec cmdList", cmdList);
        console.log("doExec cmdMode", cmdMode);
        this.cmdList = cmdList;
        this.initExecParams(cmdMode);
        // 当为cmd模式时且在此点击时，终止操作
        this.execNextMML();
      },
      syncTime(execTime) {
        this.execTime = execTime;
      },
      syncTreeData(treeData) {
        console.log("syncTreeData",treeData)
      },
      initExecParams(cmdMode) {
        this.stopFlag = 0;
        this.dangerOperChecked = false;

        // 刚开始执行的时候需要记录是否为批量修改
        // 后续在execNextMML以及MML结果接收时需要以此为判断 防止批量进行中退出批量修改的场景出现
        this.changeMassModExecingState(this.massModifyMode);
        this.changeCmdMode(cmdMode);
        this.$refs.mmlResp.recent2ExecuteResult = ['OK', 'OK'];
        // 执行前禁用按钮状态
        this.changeMmlOperButtonDisabled(true);
        if (!cmdMode) {
          this.changeMmlCmdButtonDisabled(true);
        }
      },
      execNextMML() {
        if (this.cmdList.length <= 0) {
          this.execStop();
          return;
        }
        const mml = this.cmdList.shift();
        // 高危操作检查 注意：若为批量修改 则只进行一次高危操作检查
        if (this.isMassModExecing && this.dangerOperChecked) {
          this.doAsyncExecMML(mml);
        } else {
          this.checkDangerOper(mml);
        }
      },
      checkDangerOper(mml) {
        // 先确定是否为高危操作
        this.dangerOperChecked = true;
        const params = this.packageDangerOperParams(this.currentNode, this.currentMo, mml);
        this.axios.post('/lte/ems/config/mml/dangerOper', params).then(res => {
          console.log('danger', res);
          const result = res.data.resultVal;
          if (result && result.isDanger === 'true') {
            // 获取json文件，读取高危操作提示
            const dangerOperTip = result.dangerTip ? result.dangerTip : this.$t('MML.dangerOperTip');
            // 弹出提示层，如果继续执行，则执行，否则返回
            this.$layer.warn({
              msg: dangerOperTip,
              btn1: {msg: this.$t('MML.cancel'), func: this.cancelOper},
              btn2: {
                msg: this.$t('MML.confirm'), func: () => {
                  this.doAsyncExecMML(mml);
                }
              },
            });
          } else {
            // 非高危操作 直接执行
            this.doAsyncExecMML(mml);
          }
        }).catch(err => {
          console.error(err);
          // 出现异常暂时先继续执行
          this.doAsyncExecMML(mml);
        });
      },
      cancelOper() {
        // 如果是批量修改模式 则全部取消
        if (this.isMassModExecing) {
          this.execStop();
        } else {
          // 其他模式 只取消本次操作 然后调用下一次执行
          // 如果是命令行模式 需要记录stopFlag值 stopFlag+1
          if (this.cmdMode) {
            this.stopFlag++;
            // 将count值减一，为了CommandEditor中的执行中状态显示正确
            this.$refs.mmlCommandExec.$refs.mmlEditor.count--;
          }
          this.execNextMML();
        }
      },
      execStop() {
        this.cmdList = [];
        // 还原置灰按钮 vuex
        this.changeMmlOperButtonDisabled(false);
        this.changeMmlCmdButtonDisabled(false);
      },
      doAsyncExecMML(mml) {
        console.log('mml to exec', mml);
        console.log('mml to exec time', this.execTime);
        this.setMmlHistoryCache(mml);
        // 批量修改模式 执行时需要还原状态
        if (this.massModifyMode) {
          this.$refs.mmlCommandExec.execAndExitMassMod();
        }
        const cmdType = ['cluster', 'equipment', 'ne', 'short'];
        const data = {
          neId: this.currentNode.id,
          cmd: mml,
          channelId: this.getUserId(),
          cmdType: cmdType.indexOf(this.currentNode.nodeType)
        };
        if (this.currentNode.nodeType === 'equipment') {
          data.equipmentIpId = this.findEquipmentIpId(this.currentNode, this.currentMo);
        }
        data.startTime = Date.now();

        data.executeTime = this.execTime;

        data.exportMos= sessionStorage.getItem("mml_export_mos");
        // 执行时将滚动条置顶
        this.$refs.respConsoleScroll.scrollTop = 0;
        this.axios.post('/lte/ems/config/mml/asyncExeMML', data).then((res) => {
          sessionStorage.setItem("mml_export_mos", "");
          this.execTime=0;
          // 发送成功，等待websocket响应进行下一次调用
          console.log('async res= ', res);
          if (res.data.errorCode !== 'SUCCESS') {
            this.genErrorMsgToResp(data, res.data.errorString);
          }
        }).catch((err) => {
          sessionStorage.setItem("mml_export_mos", "");
          this.execTime=0;
          console.error('async err= ', err);
          this.genErrorMsgToResp(data, this.$t('MML.execFailed'));
        });
      },
      genErrorMsgToResp(data, errorString) {
        // 异常后如果是cmdMode 需要调用deleteLine
        if (this.cmdMode) {
          bus.$emit('deleteEditorLine');
        }
        if (!errorString) {
          errorString = 'execute failed.';
        }
        // 如果异常了 生成一条异常消息 放入响应列表里 生成响应消息
        const errorMsg = {
          startTime: data.startTime,
          endTime: Date.now(),
          cmd: data.cmd,
          errorMsg: errorString,
          data: {
            Result: 'FAIL'
          }
        };
        this.$refs.mmlResp.respLst.unshift(errorMsg);
        // 然后继续下一次调用
        this.execNextMML();
      },
      setMmlHistoryCache(mml) {
        let mmlHistoryCmds = JSON.parse(localStorage.getItem('mml_history_cmds'));
        if (mmlHistoryCmds && mmlHistoryCmds.length > 99) {
          mmlHistoryCmds.pop();
        } else if (!mmlHistoryCmds) {
          mmlHistoryCmds = [];
        }
        // if (!mmlHistoryCmds.some(historyMml => historyMml.cmd === mml)) {
        //   mmlHistoryCmds.unshift({ cmd: mml });
        // }
        mmlHistoryCmds.unshift({cmd: mml});
        localStorage.setItem('mml_history_cmds', JSON.stringify(mmlHistoryCmds));
      },
      refreshCommandExec(moData) {
        // refresh the command-exec component
        this.refresh = false;
        this.$nextTick(() => {
          this.refresh = true;
          this.$nextTick(() => {
            this.$refs.mmlCommandExec.refreshTabs(moData);
          });
        });
      },
      showMassModRecord(modRecords) {
        this.showMassModRecords = true;
        // 生成批量修改数据列表
        // 生成colums
        const modRecordsColums = [];
        const attrMap = this.currentMo.attrMap
        if (modRecords && modRecords.length > 0) {
          modRecordsColums.push({type: 'checkbox', textAlign: 'Center', width: '66'});
          Object.keys(modRecords[0]).forEach(field => {
            const temColum = {};
            temColum.field = field;
            let headerText = field;
            if (attrMap[field]) {
              if ([null, 'NA', 'NO', ''].indexOf(attrMap[field].unit) < 0) {
                headerText = this.LOCALE === 'zh' ?
                  `${attrMap[field].zhName}(${attrMap[field].unit})` : `${attrMap[field].enName}(${attrMap[field].unit})`;
              } else {
                headerText = this.LOCALE === 'zh' ?
                  `${attrMap[field].zhName}` : `${attrMap[field].enName}`;
              }
              temColum.attrId = parseInt(attrMap[field].id, 10);
            }
            temColum.headerText = headerText;
            temColum.textAlign = 'Center';
            temColum.clipMode = 'EllipsisWithTooltip';
            modRecordsColums.push(temColum);
          });
        }
        this.modColumns = modRecordsColums.sort((a, b) => (a.attrId - b.attrId));
        ;
        this.modRecords = modRecords;
      },
    },
    beforeDestroy() {
      bus.$off('refreshAndLoadTabs');
      bus.$off('showMassModRecord');
    }
  };
</script>

<style>

</style>
